import React, { useEffect } from 'react';
import { Icon } from '../../../../../base/components/Icon';
import { useAppDispatch, useAppSelector } from '../../../../../base/hooks';
import { __t } from '../../../../../base/utils/t';
import { responsesActions } from '../../redux/slices/responsesSlice';
import { ResponsesRoutes } from '../../routes';
import { MutualIcon } from '../MutualIcon';
import { NavigationItem } from './NavigationItem';

import './styles.scss';

interface Props {
    className?: string;
}

export const Navigation = ({ className = '' }: Props) => {
    const dispatch = useAppDispatch();

    const {
        counters: { mutualNew, appliedNew },
        highlightArchivationIcon,
    } = useAppSelector((state) => state.employerResponses);

    useEffect(() => {
        if (highlightArchivationIcon) {
            setTimeout(() => dispatch(responsesActions.setHighlightArchivationIcon(false)), 600);
        }
    }, [highlightArchivationIcon]);

    return (
        <div className={`responses-navigation ${className}`}>
            <nav className='responses-navigation__wrap'>
                <NavigationItem
                    id='responses-navigation-applied'
                    route={ResponsesRoutes.Index}
                    icon={<Icon icon='arrow-down-regular' color='grey' />}
                    activeIcon={<Icon icon='arrow-down-regular' color='success' />}
                    text={__t('Отримані')}
                    count={appliedNew}
                />
                <NavigationItem
                    id='responses-navigation-invited'
                    route={ResponsesRoutes.Invited}
                    icon={<Icon icon='arrow-up-regular' color='grey' />}
                    activeIcon={<Icon icon='arrow-up-regular' color='highlight' />}
                    text={__t('Надіслані')}
                />
                <NavigationItem
                    id='responses-navigation-mutual'
                    route={ResponsesRoutes.Mutual}
                    icon={<MutualIcon isActive={false} />}
                    activeIcon={<MutualIcon isActive={true} />}
                    text={__t('Взаємні')}
                    count={mutualNew}
                />
                <NavigationItem
                    id='responses-navigation-archived'
                    route={ResponsesRoutes.Archived}
                    icon={<Icon icon='box-archive-regular' color='grey' />}
                    activeIcon={<Icon icon='box-archive-regular' color='danger' />}
                    text={__t('Архів')}
                    highlight={highlightArchivationIcon}
                />
            </nav>
        </div>
    );
};
